/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import clsx from "clsx";
import BookingFooterNew from "pages/Front/Booking/BookingFooterNew";

const UnsubscribeContainer = (props: {children: React.ReactNode}) => {
    return (
        <div className={"h-full flex flex-col flex-grow m-auto justify-between w-full"}>
            <div className={"relative"}>
                <div className={clsx("Booking max-w-full xl:max-w-7xl w-full items-center m-auto flex flex-col grow pt-6 pb-6 px-4 xl:px-0")} role="document">
                    {props.children}
                </div>
            </div>
            <BookingFooterNew />
        </div>
    );
};

export default UnsubscribeContainer;
